<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2>Importer le référentiel des formations via fichier Excel</h2>

        <b-col cols="10">

            <b-row class="mt-5 mb-5">
                <b-col cols="11">
                    <b-form-file
                            v-model="importFile"
                            placeholder="Choisir un fichier pour import"
                            drop-placeholder="Déposer le fichier ici"
                            browse-text="Importer un fichier"
                            accept=".xlsx"
                    ></b-form-file>
                </b-col>
                <b-col cols="1">
                    <b-button type="button" variant="success" @click="importer" :disabled="!importFile">Importer
                    </b-button>
                </b-col>
            </b-row>
        </b-col>

        <div v-if="importReferenceFormationsResult">
            <div class="overflow-auto">
                <b-table striped hover
                         :no-local-sorting="false"
                         :items="importReferenceFormationsTable" :fields="fields">
                    <template v-slot:cell(num)="row">
                        <div>
                            {{row.index + 1}}
                        </div>
                    </template>
                    <template v-slot:cell(trimestresSuivants)="row">
                        <b-button size="sm" v-b-tooltip.hover :title="row.item.trimestresSuivants">
                            <Icon icon="info-circle" size="1x"></Icon>
                        </b-button>
                    </template>
                    <template v-slot:cell(delete)="row">
                        <b-button size="sm" v-b-modal="'modal-delete' + row.item.id">
                            <Icon icon="trash" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-delete' + row.item.id"
                                title="Suppression d'une ligne d'historique"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="deleteImport(row.item.id)">
                            <p>Confirmez-vous la suppression de cette ligne d'historique ?</p>
                        </b-modal>
                    </template>
                </b-table>
            </div>
        </div>

    </div>
</template>

<script>

  import AlertStore from "../../stores/AlertStore";
  import ReferenceFormationStore from "../../stores/ReferenceFormationStore";
  import FileUtil from "../../utils/fileUtil";
  import moment from 'moment';

  export default {
    data() {
      return {
        importFile: null,
        importReferenceFormationsResult: null,
      }
    },
    computed: {
      fields() {
        return [
          {label: '', key: 'num', sortable: true},
          {label: 'Date d\'import', key: 'createdDate', sortable: true},
          {label: 'Trimestre de saisie', key: 'trimestre', sortable: true},
          {label: 'Trimestres saisis', key: 'trimestresSuivants', sortable: true},
          {label: 'Nombre de formations', key: 'nbFormations', sortable: true},
          {label: 'Nombre de sessions', key: 'nbSessions', sortable: true},
          {label: 'Nombre de métiers', key: 'nbMetiers', sortable: true},
          {label: 'Nombre d\'organismes de formation', key: 'nbOrganismes', sortable: true},
          {label: 'Lieux de formation', key: 'lieuxFormations', sortable: true},
          {label: 'Supprimer', key: 'delete', sortable: false}
        ];
      },
      importReferenceFormationsTable: function () {
        return this.importReferenceFormationsResult.map(importReferenceFormation => {
          return {
            id: importReferenceFormation.id,
            createdDate: moment(importReferenceFormation.createdDate).format("DD/MM/YYYY - HH[h]mm"),
            trimestre: importReferenceFormation.trimestre.libelle,
            trimestresSuivants: importReferenceFormation.trimestresSuivants.map(s => s.libelle).join(", "),
            nbFormations: importReferenceFormation.nbFormations,
            nbSessions: importReferenceFormation.nbSessions,
            nbMetiers: importReferenceFormation.nbMetiers,
            nbOrganismes: importReferenceFormation.nbOrganismes,
            lieuxFormations: importReferenceFormation.lieuxFormations,
          }
        });
      }
    },
    mounted() {
      this.search();
    },
    methods: {
      search() {
        ReferenceFormationStore.getImports().then(
            result => {
              this.importReferenceFormationsResult = result.data;
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      importer() {
        ReferenceFormationStore.importExcel(this.importFile).then(
            result => {
              if (result.status === 200) {
                AlertStore.pushWarning("Le fichier importé comporte des erreurs, veuillez consulter le rapport d'erreur");
                FileUtil.downloadFile(result.data, 'text/csv;charset=utf8;');
              }
              if (result.status === 204) {
                AlertStore.pushSuccess("Fichier importé avec succès");
                this.search();
              }
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      deleteImport(id) {
        ReferenceFormationStore.deleteImport(id).then(() => {
          this.search();
        });
      },
    }
  }
</script>

